<script>
	import MediaQuery from 'svelte-media-query'
	import { page } from '$app/stores'
	import { MEDIA_QUERY } from '$lib/consts'
	import { t } from '$lib/translations'
	import { Button } from '$lib/ui-woltair/components'

	export let header = null

	export let inStockSlugs = []

	const mainImage = header.mainImage.data.attributes
	const mainImageMobile = header?.mainImageMobile?.data?.attributes || null
</script>

<div class="background-full">
	<div class="background">
		<MediaQuery query={`(max-width: ${MEDIA_QUERY.MD})`} let:matches>
			<img
				alt={mainImage.alternativeText}
				src={matches && mainImageMobile ? mainImageMobile?.url : mainImage.url}
			/>
		</MediaQuery>
	</div>
	<header>
		<h1>{header?.title}</h1>
		<h3 class="mb-2">
			{header?.warranty}
			<span class="text-white">|</span>
			{header?.countryProduced}
		</h3>
		{#if inStockSlugs.includes($page.params.brand)}
			<div class="white flex max-w-fit">
				<div class="green flex max-w-fit">
					<img src="/images/icons/package.svg" alt="Balíček" />
					<span>{t('web.heat_pump.brands.availability.option1')}</span>
				</div>
			</div>
		{/if}
		<div>
			<Button href={header?.mainButtonURL}>{header?.mainButtonText}</Button>
		</div>
	</header>
</div>

<style lang="scss">
	.white {
		background: #fff;
		border-radius: 20px;
		padding: 8px;
		margin-bottom: 20px;
		gap: 15px;
		align-items: center;

		@media (max-width: 760px) {
			padding: 5px;
			gap: 10px;
		}

		.green {
			flex: 1 0 150px;
			height: 100%;
			padding: 10px;
			gap: 15px;
			align-items: center;
			background: #147c35;
			color: #fff;
			font-weight: bold;
			border-radius: 15px;

			@media (max-width: 760px) {
				flex: 1 0 110px;
				gap: 5px;
				padding: 8px;
			}

			& > span {
				display: block;
				font-size: 18px;
				color: #fff;

				@media (max-width: 760px) {
					font-size: 12px;
				}
			}

			img {
				width: 30px;
			}
		}
	}

	.background-full {
		height: calc(100vh - 80px);
		position: relative;

		.background {
			position: absolute;
			display: block;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
				object-position: bottom;
			}

			&::after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: #00000066;
			}
		}

		header {
			position: absolute;
			z-index: 2;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			flex-direction: column;
			padding: 0 15%;

			@media only screen and (max-width: 760px) {
				padding: 0 15px;
			}

			& > h1,
			& > h3 {
				color: #fff;
			}
		}
	}
</style>
